import "./VehiclesFilters.scss";

import { useSelector } from "react-redux";

import { useGetVehiclesFilters } from "../../../../hooks/useGetVehiclesFilters";
import { useGetVehiclesFiltersWithOptions } from "../../../../hooks/useGetVehiclesFiltersWithOptions";

import { FilterField } from "../../../../common-components/FilterField/FilterField";

const VehiclesFilters = () => {
    const componentId = "vehicles";
    const token = useSelector((state) => state.auth.token);
    const { filters: rawFilters } = useGetVehiclesFilters();
    const { filters } = useGetVehiclesFiltersWithOptions(rawFilters, token);

    if (!filters) {
        return null
    }

    return (
        <div className={"vehicles-filters"}>
            <div className={"vehicles-filters_container"}>
                <div className={"vehicles-filters_items"}>
                    {Object.entries(filters).map(([filterKey, filter]) => (
                        <FilterField
                            name={filter.name}
                            key={filterKey}
                            label={filter.label || filter.alias}
                            type={filter.type}
                            propertyLabel={filter.alias || filter.label}
                            filterKey={filter.filterKey}
                            componentId={componentId}
                            filterStructure={filter}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default VehiclesFilters;